import React from 'react';

const LoadingPage = () => (
    <div className="loader">
        <img className="loader__image" src="/images/loader.gif" />
    </div>
);

export default LoadingPage;


// WEBPACK FOOTER //
// ./src/components/LoadingPage.js